import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ModernHeader from './components/ModernHeader';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Geschichte from './pages/Geschichte';
import Trainings from './pages/Trainings';
import Events from './pages/Events';
import Contact from './pages/Contact';
import Platzordnung from './pages/Platzordnung';
import SportDetail from './pages/SportDetail';
import Unterordnung from './pages/Unterordnung';
import NotFound from './pages/NotFound';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
          <ModernHeader />
          <main role="main" className="pt-16 lg:pt-20">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/geschichte" element={<Geschichte />} />
              <Route path="/trainings" element={<Trainings />} />
              <Route path="/termine" element={<Events />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/platzordnung" element={<Platzordnung />} />
              <Route path="/unterordnung" element={<Unterordnung />} />
              <Route path="/sport/:sport" element={<SportDetail />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
